<template>
  <div>
    <!-- 智能写稿 优化按钮 -->
    <div
      ref="optimize_btn"
      v-show="showOptimizeBtn"
      class="optimize-btn"
      :style="btnPosition"
      @click="showOptimizeModal"
    >
      <div class="optimize-btn-icon"></div>优化
    </div>
    <!-- 智能写稿 优化弹窗 -->
    <div
      ref="optimize_modal"
      class="optimize-modal"
      @click.stop
      v-show="showModal"
      :style="modalPosition"
    >
      <div class="head">
        <div class="l">
          <div class="optimize-btn-icon icon"></div>
          <div class="title">优化</div>
        </div>
        <div class="r">
          <div @click="closeOptimizeBtn" class="close"></div>
        </div>
      </div>

      <div class="foot">
        <div class="input">
          <textarea
            @focus.stop
            @keydown="handleInput"
            maxlength="2000"
            v-model.trim="queryText"
            placeholder="在此输入你的问题，shift+enter换行"
            type="text"
          />
          <div @click="search" class="search"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiOptimizeWriter_Common',
  props: {
    apply_container: {
      type: Array,
    },
  },
  watch: {
    apply_container: {
      deep: true,
      immediate: true,
      handler(nv, ov) {
        console.log('watch apply_container', nv, ov);
        if (nv && nv.length && !this.hasInitContainer) {
          console.log('注册时间');
          this.apply_container.forEach((container) => {
            container.addEventListener('focus', (e) => {
              console.log('container common focus', e, e.target);
              this.$emit('focus', this);
              this.optimizeContainer = e.target;
            });
            // container.addEventListener('keydown', (e) => {
            //   console.log('container keydown', e);
            //   if (this.showOptimizeBtn) {
            //     console.log('keydown 不是优化按钮的地方');
            //     this.lastSelection = '';
            //     this.showOptimizeBtn = false;

            //     const selection = window.getSelection();
            //     let cloneRange;
            //     if (selection.rangeCount) {
            //       console.log('keydown 有选区');
            //       cloneRange = selection.getRangeAt(0);
            //     } else {
            //       console.log('keydown 没有选区');
            //     }

            //     container.focus();
            //     if (cloneRange) {
            //       selection.addRange(cloneRange);
            //     }
            //   }
            // });
            container && container.addEventListener('mouseup', this.handleSelection);
          });
          this.hasInitContainer = true;
        }
      },
    },
  },
  data() {
    return {
      showOptimizeBtn: false,
      showModal: false,
      // showModal: true,
      btnPosition: {},
      modalPosition: {},
      lastSelection: null,
      highlightElement: null,
      cloneRangeContent: '',
      queryText: '',
      // 是点击出现优化 输入弹窗前，保存的选区对象，用来之后恢复选区
      savedSelection: null,
    };
  },
  mounted() {
    document.addEventListener('selectionchange', this.handleSelection2);
    document.addEventListener('mousedown', this.handleClickOutside);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener('selectionchange', this.handleSelection2);
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleSelection2(e) {
      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) {
        return;
      }
      const range = selection.getRangeAt(0);
      const container = range.commonAncestorContainer;
      // 如果当前选区不在  optimize_container 中
      if (!this.optimizeContainer.contains(container)) {
        return;
      } else {
        // console.log('handleSelection2 如果当前选区在');
        if (this.showOptimizeBtn && selection.isCollapsed) {
          this.showOptimizeBtn = false;
          this.lastSelection = null;
        }
      }
    },
    replaceNBSP2Blank(source) {
      return source.replace(/&nbsp;/gi, ' ');
    },
    replaceBrTagsWithNewlines(str, isRemoveLine) {
      str = str.replace(/<br\s*\/?>/gi, '\n');
      if (isRemoveLine) {
        str = str.replaceAll('\n', '');
      }
      str = str.trim();
      return str;
    },
    // 将内容A复制到原来的higHLightElement，并且去掉 原来的高亮 element 去掉高亮样式，选区在 复制完成的内容最后
    /**
     *  暴露给外部调用的，将 innerHTML 替换到 highlightElement 或者 当前的选区
     * @param innerHTML
     */
    copy(innerHTML) {
      // 如果是标题，特殊处理。文本需要处理换行，且字数
      console.log('copy optimizeContainer', this.optimizeContainer);
      if (this.optimizeContainer && this.optimizeContainer.classList.contains('title_editor')) {
        if (this.highlightElement) {
          this.copy2HightElementTitle(innerHTML);
        }
        // 处理 当前的选区，如果有的话
        else {
          const selection = window.getSelection();
          if (!selection.rangeCount || selection.isCollapsed) {
            console.log('当前编辑器中 没有任何可以替换的内容');
            this.$emit('exchangeContent', innerHTML);
            return;
          } else {
            const range = selection.getRangeAt(0);
            this.lastSelection = range;
            this.copy2SelectionTitle(innerHTML);
          }
        }
      } else {
        // 如果当前是 有高亮element
        console.log('copy lastSelection', this.lastSelection);
        if (this.highlightElement) {
          this.copy2HightElement(innerHTML);
        }
        // 处理 当前的选区，如果有的话
        else {
          const selection = window.getSelection();
          if (!selection.rangeCount || selection.isCollapsed) {
            console.log('当前编辑器中 没有任何可以替换的内容');
            this.$emit('exchangeContent', innerHTML);
            return;
          } else {
            const range = selection.getRangeAt(0);
            this.lastSelection = range;
            this.copy2Selection(innerHTML);
          }
        }
      }
    },
    copy2Selection(innerHTML) {
      if (!this.lastSelection) return;
      console.log('优化弹窗 oncopy', innerHTML);

      // 创建新内容节点
      const newNode = document.createElement('span');
      newNode.innerHTML = this.replaceBrTagsWithNewlines(this.replaceNBSP2Blank(innerHTML));
      // newNode.innerHTML = document.querySelector('.result').innerHTML;
      console.log('newNode', newNode, newNode.innerHTML);
      const documentFragment = document.createDocumentFragment();
      let lastNode = newNode.lastChild;
      while (newNode.firstChild) {
        documentFragment.appendChild(newNode.firstChild);
      }
      console.log('copy2Selection documentFragment', documentFragment);
      this.lastSelection.deleteContents();
      this.lastSelection.insertNode(documentFragment);

      // 设置选区到新内容末尾
      const range = document.createRange();
      const selection = window.getSelection();

      range.setStartAfter(lastNode);
      range.collapse(true);

      selection.removeAllRanges();
      selection.addRange(range);
      this.lastSelection = null;
      this.showOptimizeBtn = false;
      this.showModal = false;
    },
    copy2SelectionTitle(innerHTML) {
      if (!this.lastSelection) return;
      console.log('优化弹窗 oncopy', innerHTML);

      // 创建新内容节点
      let newNode = document.createElement('span');
      newNode.innerHTML = this.replaceBrTagsWithNewlines(this.replaceNBSP2Blank(innerHTML), true);
      newNode.innerHTML = newNode.innerText.trim();
      let text = this.$parent.handlePasteTitleExpose(newNode.innerText, this.lastSelection.toString().length);
      console.log('copy2SelectionTitle handlePasteTitleExpose text', text);

      newNode.innerHTML = text;
      // newNode.innerHTML = document.querySelector('.result').innerHTML;
      console.log('newNode', newNode, newNode.innerHTML);
      const documentFragment = document.createDocumentFragment();
      let lastNode = newNode.lastChild;
      while (newNode.firstChild) {
        documentFragment.appendChild(newNode.firstChild);
      }
      console.log('copy2Selection documentFragment', documentFragment);
      this.lastSelection.deleteContents();
      this.lastSelection.insertNode(documentFragment);

      // 设置选区到新内容末尾
      const range = document.createRange();
      const selection = window.getSelection();

      range.setStartAfter(lastNode);
      range.collapse(true);

      selection.removeAllRanges();
      selection.addRange(range);
      this.lastSelection = null;
      this.showOptimizeBtn = false;
      this.showModal = false;
      // 手动触发input事件
      this.$nextTick(() => {
        const event = new Event('input', { bubbles: true });
        this.optimizeContainer.dispatchEvent(event);
      });
      newNode = null;
    },
    copy2HightElement(innerHTML) {
      if (!this.highlightElement) return;
      console.log('优化弹窗 oncopy', innerHTML);

      // 创建新内容节点
      const newNode = document.createElement('span');
      newNode.innerHTML = this.replaceBrTagsWithNewlines(innerHTML);
      // newNode.innerHTML = document.querySelector('.result').innerHTML;
      console.log('newNode', newNode, newNode.outerHTML);
      const documentFragment = document.createDocumentFragment();
      while (newNode.firstChild) {
        documentFragment.appendChild(newNode.firstChild);
      }

      // 替换高亮元素
      const parent = this.highlightElement.parentNode;
      parent.insertBefore(documentFragment, this.highlightElement);

      // 设置选区到新内容末尾
      const range = document.createRange();
      const selection = window.getSelection();

      range.setStartAfter(this.highlightElement);
      range.collapse(true);

      selection.removeAllRanges();
      selection.addRange(range);

      parent.removeChild(this.highlightElement);
      this.highlightElement = null;
      // todo 查看之前的缓存
      this.savedSelection = null;
      this.showModal = false;
      this.lastSelection = null;
      this.showOptimizeBtn = false;
    },
    copy2HightElementTitle(innerHTML) {
      if (!this.highlightElement) return;
      console.log('优化弹窗 oncopy', innerHTML);

      // 创建新内容节点
      const newNode = document.createElement('span');
      newNode.innerHTML = this.replaceBrTagsWithNewlines(this.replaceNBSP2Blank(innerHTML), true);
      newNode.innerHTML = newNode.innerText.trim();
      let text = this.$parent.handlePasteTitleExpose(newNode.innerText, this.highlightElement.innerText.length);
      console.log('handlePasteTitleExpose text', text);

      // 转为纯文本
      newNode.innerHTML = text;
      // this.optimizeContainer
      // newNode.innerHTML = document.querySelector('.result').innerHTML;
      console.log('newNode', newNode, newNode.outerHTML);
      const documentFragment = document.createDocumentFragment();
      while (newNode.firstChild) {
        documentFragment.appendChild(newNode.firstChild);
      }

      // 替换高亮元素
      const parent = this.highlightElement.parentNode;
      parent.insertBefore(documentFragment, this.highlightElement);

      // 设置选区到新内容末尾
      const range = document.createRange();
      const selection = window.getSelection();

      range.setStartAfter(this.highlightElement);
      range.collapse(true);

      selection.removeAllRanges();
      selection.addRange(range);

      parent.removeChild(this.highlightElement);

      this.highlightElement = null;
      // todo 查看之前的缓存
      this.savedSelection = null;
      this.showModal = false;
      this.lastSelection = null;
      this.showOptimizeBtn = false;
      // 手动触发input事件
      this.$nextTick(() => {
        const event = new Event('input', { bubbles: true });
        this.optimizeContainer.dispatchEvent(event);
      });
    },
    search() {
      if (!this.queryText || !this.queryText.length) {
        return;
      }
      this.$emit('search', { queryText: this.queryText, selectionText: this.highlightElement.innerText.trim() });
      console.log('search queryText', this.queryText);
      console.log('search 选区的 文本内容', this.highlightElement.innerText);
      this.queryText = '';
      this.showModal = false;
      this.showOptimizeBtn = false;
    },
    handleInput(event) {
      if (event.key === 'Enter' && event.shiftKey) {
        console.log('Shift + Enter pressed');
        console.log('去 换行');
      } else if (event.key === 'Enter') {
        console.log('去 search');
        event.preventDefault();
        this.search();
      }
    },
    toggleShowContent() {
      console.log('toggleShowContent');
    },

    copyContent() {
      let text = `ai生成的优化文本`;
      if (this.highlightElement) {
        this.highlightElement.innerHTML = text;
        let parent = this.highlightElement.parentNode;

        while (parent && this.highlightElement.firstChild) {
          parent.insertBefore(this.highlightElement.firstChild, this.highlightElement);
        }
        parent && parent.removeChild(this.highlightElement);
        this.highlightElement = null;
      }
    },
    clearSelfSelection(notClearFocus) {
      this.showOptimizeBtn = false;
      this.showModal = false;
      this.lastSelection = null;
      this.queryText = '';
      console.log('clearSelfSelection common');
      // 如果需要失去焦点
      if (!notClearFocus) {
        const selection = window.getSelection();
        selection.removeAllRanges();
      }

      // 如果已经点击优化，出来优化弹窗，要把之前的 已经框出来的文本 还原
      if (this.highlightElement) {
        // 清除旧高亮
        const parent = this.highlightElement.parentNode;
        while (parent && this.highlightElement.firstChild) {
          parent.insertBefore(this.highlightElement.firstChild, this.highlightElement);
        }
        parent && parent.removeChild(this.highlightElement);
        this.highlightElement = null;
        this.savedSelection = null;
      }
    },

    handleSelection() {
      const selection = window.getSelection();
      // 如果当前 只是点中，不隐藏
      // 只有在选中别的文本，有内容时，才清除之前的选区
      // console.log('handleSelection 11');
      if (!selection.rangeCount || selection.isCollapsed) {
        console.log('没有选区 去 clearSelfSelection common');
        this.clearSelfSelection(true);
        return;
      }

      const range = selection.getRangeAt(0);
      // console.log('handleSelection hanshu', range, range.toString());

      if (!this.optimizeContainer.contains(range.commonAncestorContainer)) return;

      this.lastSelection = range;

      // console.log('handleSelection lastSelection', this.lastSelection, this.lastSelection.toString());

      this.positionButton(range);
    },
    // 定位优化按钮，需要是 选区最后选到的位置，而不是整个矩形选区的最右方，换行情况下
    positionButton(range) {
      // 创建临时光标定位元素
      const tempSpan = document.createElement('span');
      tempSpan.style.visibility = 'hidden';
      // 原本选区矩形的开始
      let original_rect = range.getBoundingClientRect();
      // 2. 创建只包含终点位置的微范围
      const endRange = document.createRange();
      endRange.setStart(range.endContainer, range.endOffset);
      endRange.setEnd(range.endContainer, range.endOffset);
      // 插入到选区结束位置
      endRange.insertNode(tempSpan);

      // 获取位置
      const rect = tempSpan.getBoundingClientRect();
      // console.log('选中选区 结尾的位置', rect);
      // console.log('选中选区 pageXOffset pageYOffset ', window.pageXOffset, window.pageYOffset);
      // 移除临时元素
      tempSpan.parentNode.removeChild(tempSpan);
      // 编辑器的左侧left

      this.editorLeft = this.optimizeContainer.getBoundingClientRect().left;

      const btnW = 80;
      const btn_offsetX = 106;

      let minLeft = Math.max(rect.left - btnW - btn_offsetX, this.editorLeft, original_rect.left);

      this.btnPosition = {
        top: `${rect.top + rect.height}px`,
        left: `${minLeft}px`,
      };
      this.showOptimizeBtn = true;
    },
    closeOptimizeBtn() {
      // 如果已经点击优化，出来优化弹窗，要把之前的 已经框出来的文本 还原
      if (this.highlightElement) {
        console.log('savedSelection', this.savedSelection, this.savedSelection.toString());
        // 清除旧高亮
        const parent = this.highlightElement.parentNode;
        while (parent && this.highlightElement.firstChild) {
          parent.insertBefore(this.highlightElement.firstChild, this.highlightElement);
        }

        parent && parent.removeChild(this.highlightElement);
        this.highlightElement = null;

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(this.savedSelection);
      }
      this.queryText = '';
      this.showModal = false;
      this.showOptimizeBtn = true;
    },
    showOptimizeModal() {
      if (!this.lastSelection) return;
      // console.log('showOptimizeModal lastSelection', this.lastSelection, this.lastSelection && this.lastSelection.toString());

      // console.log('showOptimizeModal highlightElement', this.highlightElement);

      // 如果选区被包含在 highlightElement，则先处理选区 再 清除高亮
      if (this.highlightElement && this.highlightElement.contains(this.lastSelection.startContainer)) {
        // console.log('highlightElement 包含了 lastSelection');

        // 提取出来选区的内容 fragment形式 添加选中的样式
        let extractFM = this.lastSelection.extractContents();
        // 创建新高亮
        const span = document.createElement('span');
        span.className = 'selection-highlight';

        // console.log('extractFM', extractFM);

        span.appendChild(extractFM);
        // 再回插入到 选区起点
        this.lastSelection.insertNode(span);
        // 保存选区，close优化的时候，可以还原选区
        this.savedSelection = this.lastSelection.cloneRange();
        // console.log('先处理选区的 savedSelection', this.savedSelection, this.savedSelection.toString());
        if (this.highlightElement) {
          // 清除旧高亮
          const parent = this.highlightElement.parentNode;
          while (this.highlightElement.firstChild) {
            parent.insertBefore(this.highlightElement.firstChild, this.highlightElement);
          }
          parent && parent.removeChild(this.highlightElement);

          this.highlightElement = null;
        }
        this.highlightElement = span;

        // // 定位弹窗
        const rect = span.getBoundingClientRect();
        let editorLeft = this.optimizeContainer.getBoundingClientRect().left;
        let left = Math.max(rect.left + rect.width - 482, editorLeft);
        this.modalPosition = {
          top: `${rect.bottom + window.pageYOffset}px`,
          left: `${left + window.pageXOffset}px`,
        };
      } else {
        if (this.highlightElement) {
          // 清除旧高亮
          const parent = this.highlightElement.parentNode;
          while (this.highlightElement.firstChild) {
            parent.insertBefore(this.highlightElement.firstChild, this.highlightElement);
          }
          parent && parent.removeChild(this.highlightElement);

          this.highlightElement = null;
        }
        // console.log('进入了 清除旧高亮 后续逻辑');
        // 创建新高亮
        const span = document.createElement('span');
        span.className = 'selection-highlight';
        let extractFM = this.lastSelection.extractContents();
        // console.log('extractFM', extractFM);

        span.appendChild(extractFM);

        // console.log('放进 span中', span.innerHTML);
        // 再回插入到 选区起点
        this.lastSelection.insertNode(span);

        this.highlightElement = span;
        // 保存选区，close优化的时候，可以还原选区
        this.savedSelection = this.lastSelection.cloneRange();
        // console.log('savedSelection', this.savedSelection, this.savedSelection.toString());
        // // 定位弹窗
        const rect = span.getBoundingClientRect();
        let editorLeft = this.optimizeContainer.getBoundingClientRect().left;
        let left = Math.max(rect.left + rect.width - 482, editorLeft);
        this.modalPosition = {
          top: `${rect.bottom + window.pageYOffset}px`,
          left: `${left + window.pageXOffset}px`,
        };
      }

      this.showOptimizeBtn = false;
      this.showModal = true;
      // console.log('showOptimizeModal highlightElement', this.highlightElement, this.highlightElement.innerText);
    },

    handleClickOutside(e) {
      // console.log('mousedown e', e.target, this.$refs.input_box.contains(e.target));
      // console.log('mousedown lastSelection', this.lastSelection, this.lastSelection && this.lastSelection.toString());
      // console.log('mousedown highlightElement', this.highlightElement);
      console.log('mousedown common', e.target);

      // 如果点了不是优化按钮的地方，且当前只是选中文本 显示优化按钮。需要清除
      if (this.showOptimizeBtn && !this.$refs.optimize_btn.contains(e.target) && !document.querySelector('.test_optimize').contains(e.target)) {
        console.log('如果点了不是优化按钮的地方');
        this.lastSelection = '';
        this.showOptimizeBtn = false;
        const selection = window.getSelection();
        selection.removeAllRanges();
      } else if (
        !document.querySelector('.test_optimize').contains(e.target) &&
        !this.optimizeContainer.contains(e.target) &&
        !this.$refs.optimize_btn.contains(e.target) &&
        !this.$refs.optimize_modal.contains(e.target) &&
        (document.querySelector('#aiOptimizeWriterDialog') ? !document.querySelector('#aiOptimizeWriterDialog').contains(e.target) : true)
      ) {
        console.log('点击了应该消失的区域 common');
        this.showOptimizeBtn = false;
        this.showModal = false;
        this.queryText = '';

        // 清除高亮
        if (this.highlightElement) {
          const parent = this.highlightElement.parentNode;
          while (this.highlightElement.firstChild) {
            parent.insertBefore(this.highlightElement.firstChild, this.highlightElement);
          }
          parent.removeChild(this.highlightElement);
          this.highlightElement = null;
          this.savedSelection = null;
        }
      } else {
        console.log('点了 whitellist', e.target);
      }
    },

    handleScroll() {
      // 如果当前是展开优化弹窗
      if (this.highlightElement) {
        const rect = this.highlightElement.getBoundingClientRect();
        let editorLeft = this.optimizeContainer.getBoundingClientRect().left;
        let left = Math.max(rect.left + rect.width - 482, editorLeft);

        this.modalPosition = {
          top: `${rect.bottom + window.pageYOffset}px`,
          left: `${left + window.pageXOffset}px`,
        };
      }
      // 如果当前是 优化按钮
      else if (this.showOptimizeBtn && this.lastSelection) {
        this.positionButton(this.lastSelection);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.test-style {
  color: teal;
  display: inline;
}
.editor {
  width: 600px;
  height: 300px;
  border: 1px solid #ccc;
  padding: 20px;
  margin: 50px auto;
}

.optimize-btn {
  z-index: 1001;
  position: fixed;

  cursor: pointer;
  width: 80px;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 500;
  font-size: 13px;
  color: #050f0f;
  box-sizing: border-box;
  &-icon {
    width: 20px;
    height: 20px;
    background: url('./assets/optimize_btn.png') center no-repeat;
    background-size: cover;
  }
}

/* 修改选区的背景色 */
::selection {
  background: rgba(65, 180, 140, 0.15);
}

/* 针对较旧版本的WebKit浏览器（如Safari） */
::-moz-selection {
  /* Firefox专用 */
  background: rgba(65, 180, 140, 0.15);
}
</style>
<style lang="less">
.selection-highlight {
  background: rgba(65, 180, 140, 0.15);
  position: relative;
  padding: 2px 4px;
  border-radius: 3px;
}

.optimize-modal {
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 999;
  width: 482px;
  height: 186px;
  background: url('./assets/optimize_bg.png') no-repeat;

  box-sizing: border-box;
  background-position: -14px -6px;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;

    border-radius: 12px 12px 0px 0px;

    padding: 0 20px;
    box-sizing: border-box;

    .l {
      display: flex;
      align-items: center;

      .icon {
        display: block;
        width: 22px;
        height: 22px;
        background: url('./assets/optimize_btn.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-right: 6px;
      }

      .title {
        font-size: 16px;
        color: #050f0f;
        font-weight: bold;
      }
    }

    .r {
      display: flex;
      align-items: center;

      .close {
        width: 20px;
        height: 20px;
        background: url('./assets/sq.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-left: 10px;
        user-select: none;
        cursor: pointer;
      }
    }
  }

  .foot {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    background: #ffffff;
    border-radius: 12px;
    padding: 10px;
    margin: 6px 10px 0;
    box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.2);
    .input {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      min-width: 0;
      height: 100px;
      border-radius: 12px;
      background: #f6f8fb;
      padding: 10px;
      box-sizing: border-box;

      textarea {
        flex: 1;
        min-width: 0;
        height: 100%;
        background: transparent;
        resize: none;
        border: 0;
        outline: none;
        &::placeholder {
          color: #b9c3c3;
        }
      }

      .search {
        width: 28px;
        height: 28px;
        background: url('./assets/search.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        user-select: none;
        cursor: pointer;
        margin-left: 10px;
        align-self: flex-end;
      }
    }

    .current {
      position: absolute;
      z-index: 9;
      right: 20px;
      top: -44px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 72px;
      height: 30px;
      background: rgba(231, 232, 233, 1);
      border-radius: 8px;
      user-select: none;
      cursor: pointer;
      font-weight: 500;
      font-size: 13px;
      line-height: 30px;
      color: #050f0f;
    }

    .stop {
      position: absolute;
      z-index: 9;
      left: 20px;
      top: -44px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 92px;
      height: 30px;
      background: rgba(249, 231, 232, 1);
      border-radius: 8px;
      user-select: none;
      cursor: pointer;

      .del {
        display: block;
        width: 14px;
        height: 14px;
        background: url('./assets/del.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-right: 6px;
      }

      span {
        font-weight: 500;
        font-size: 13px;
        line-height: 30px;
        color: #050f0f;
      }
    }
  }
}
</style>
